class ReCoPoError extends Error {
  /**
   * ReCoPoのカスタムエラー。
   * ユーザーに見えてもいいエラーメッセージをおく
   */
  constructor(message: string) {
    super(message);
    this.name = new.target.name;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export default ReCoPoError;
